import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Addresses_ModuleContextService } from './Addresses.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Addresses_ownersaccounts_dd_ComponentContextService {
  private readonly moduleContext: Addresses_ModuleContextService;

  constructor(moduleContext: Addresses_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'ownersaccounts_dd',
      type: ComponentType.selector
    }
  }
}